import { render, staticRenderFns } from "./HeaderApp.vue?vue&type=template&id=4b1dcdee&scoped=true&"
import script from "./HeaderApp.vue?vue&type=script&lang=js&"
export * from "./HeaderApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1dcdee",
  null
  
)

export default component.exports